module.exports = __webpack_public_path__ + "media/icons/default_pfp_2d-9f375bb0.svg";